module.exports = __webpack_public_path__ + "img/full1-min.134277e9.png";